import React from 'react';
import CompanyHeader from './CompanyHeader';
import CompanySidebar from './CompanySidebar';

const CompanyLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <CompanyHeader />
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div className="d-none d-lg-block">
          <CompanySidebar />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default CompanyLayout;
